/**
 * For different parts of Wooting we can have different region designations.
 * In this file you'll find definitions and converter helpers
 *
 * We have 3 categories of regions:
 * 1. StoreRegions: These are the regions of the Shopify store with Order Desk backend tied to a fulfilment center.
 * 2. PurchaseOrderRegions: Regions of the Purchase Orders in the Database. These are practically fulfilment centers.
 * 3. ShippingInfoRegions: These are the regions of the Shipping Info in the Database. In general these match with the fulfilment center regions.
 *
 * PurchaseOrderRegions and ShippingInfoRegions are split because of backwards compatibility. PO Regions are numbers, ShippingInfoRegions are strings.
 */

/**
 * @description The region of the store. This is used to determine which store to use for Shopify and Order Desk.
 */
export enum StoreRegion {
  /** Active Regions */
  /** @description EU Store with EU (Monta) Fulfilment */
  EU = "EU",

  /** @description US Store with US (Shiphero) Fulfilment. */
  STORE_US = "STORE_US",

  /** @description ROW Store with EU (Monta) Fulfilment. */
  ROW = "ROW",

  /** @description ROW Store with HK (CBIP) Fulfilment. */
  ROW_HK = "ROW_HK",

  /** @description China Store with China (KLN) Fulfilment. */
  CN_DOMESTIC = "CN_DOMESTIC",

  /** @description China Store with China (KLN) Bonded Fulfilment. */
  CN_BONDED = "CN_BONDED",

  /** Inactive / Test Regions */
  /** @deprecated Archived store, use STORE_US for US sales */
  NA = "NA",

  /** @description Region for development purposes */
  TEST = "TEST",
}

enum CsvOrderRegion {
  ARCHIVE = "ARCHIVE",
}

export type OrderRegion = StoreRegion | CsvOrderRegion;
